import { MODULE_NAME, PERMISSION } from './permission.constant';

export const menuItems = [
  {
    // permission: [PERMISSION.DASHBOARD_LEADS, PERMISSION.DASHBOARD_JOBCARD],
    permission: [PERMISSION.DASHBOARD_FORM_SUB, PERMISSION.DASHBOARD_VISITOR],
    iconComponent: 'dashIcon',
    title: 'Dashboard',
    keyId: 'dashboard',
    path: '/dashboard',
    isCollapsing: true,
    children: [],
  },
  {
    permission: [
      PERMISSION.HOME_READ,
      PERMISSION.SELL_CAR_READ,
      PERMISSION.AFTER_SALES_SERVICES_READ,
      PERMISSION.AUCTIION_READ,
      PERMISSION.OUR_STORY_READ,
      PERMISSION.TERM_OF_USE_READ,
      PERMISSION.PRIVACY_POLICY_READ,
    ],
    iconComponent: 'pageIcon',
    title: 'Page Management',
    keyId: 'pages',
    path: '/pages',
    isCollapsing: true,
    children: [],
  },
  {
    permission: [PERMISSION.BANNER_READ],
    iconComponent: 'iconBanner',
    title: 'Banner',
    keyId: 'banner',
    path: '/banner/edit',
    isCollapsing: true,
    children: [],
  },
  {
    permission: [PERMISSION.WIDGET_READ],
    iconComponent: 'iconWidgete',
    title: 'Widget',
    keyId: 'widget',
    path: '/widget/edit',
    isCollapsing: true,
    children: [],
  },
  {
    permission: [PERMISSION.SLIDER_MANAGEMENT_READ],
    iconComponent: 'iconSlider',
    title: 'Slider Management',
    keyId: 'slider',
    path: '/slider',
    isCollapsing: true,
    children: [],
  },
  {
    permission: [PERMISSION.PROMOTION_READ],
    iconComponent: 'iconPro',
    title: 'Promotion',
    keyId: 'promotion',
    path: '/promotion/edit',
    isCollapsing: true,
    children: [],
  },

  {
    permission: [PERMISSION.CAR_MANAGEMENT_READ],
    iconComponent: 'iconCar',
    title: 'Car Management',
    keyId: 'vehicle',
    path: '/vehicles',
    isCollapsing: true,
    children: [],
  },

  {
    permission: [PERMISSION.BUY_CAR_READ, PERMISSION.INBOX_SELL_CAR_READ, PERMISSION.SERVICE_READ],
    iconComponent: 'iconInb',
    title: 'Inbox',
    keyId: 'inbox',
    path: '/inbox/buy-car',
    isCollapsing: true,
    badge: 0,
    children: [
      {
        title: 'Buy Car',
        keyId: 'inbox-buy-car',
        path: '/inbox/buy-car',
        permission: PERMISSION.BUY_CAR_READ,
        badge: 0,
      },
      {
        title: 'Sell Car',
        keyId: 'inbox-sell-car',
        path: '/inbox/sell-car',
        permission: PERMISSION.INBOX_SELL_CAR_READ,
        badge: 0,
      },
      {
        title: 'Services',
        keyId: 'inbox-after-sales',
        path: '/inbox/after-sales',
        permission: PERMISSION.SERVICE_READ,
        badge: 0,
      },
    ],
  },

  {
    permission: [PERMISSION.CUSTOMER_REVIEW_READ],
    iconComponent: 'iconCus',
    title: 'Customer Review',
    keyId: 'customer-review',
    path: '/customer-review',
    isCollapsing: true,
    children: [],
  },

  {
    permission: [PERMISSION.NEW_READ, PERMISSION.NEW_PROMOTION_READ, PERMISSION.AUTHOR_READ],
    iconComponent: 'iconNew',
    title: 'News',
    keyId: 'news',
    path: '/news/new',
    isCollapsing: true,
    children: [
      {
        title: 'News',
        keyId: 'news-new',
        path: '/news/new',
        permission: PERMISSION.NEW_READ,
      },
      {
        title: 'Promotion',
        keyId: 'news-promotion',
        path: '/news/promotion',
        permission: PERMISSION.NEW_PROMOTION_READ,
      },
      {
        title: 'Author',
        keyId: 'news-author',
        path: '/news/author',
        permission: PERMISSION.AUTHOR_READ,
      },
    ],
  },

  {
    permission: [PERMISSION.CUSTOMER_READ],
    iconComponent: 'iconCustomer',
    title: 'Customer',
    keyId: 'customers',
    path: '/customers',
    isCollapsing: true,
    children: [],
  },

  {
    permission: [PERMISSION.CAREER_READ, PERMISSION.HOW_TO_APPLY_READ],
    iconComponent: 'iconCareer',
    title: 'Career',
    keyId: 'career',
    path: '/career/career',
    isCollapsing: true,
    children: [
      {
        title: 'Career',
        keyId: 'career-career',
        path: '/career/career',
        permission: PERMISSION.CAREER_READ,
      },
      {
        title: 'How to Apply',
        keyId: 'career-how-apply',
        path: '/career/how-apply',
        permission: PERMISSION.HOW_TO_APPLY_READ,
      },
    ],
  },

  {
    permission: [PERMISSION.FAQ_READ],
    iconComponent: 'iconFaq',
    title: 'FAQ',
    keyId: 'faqs',
    path: '/faqs',
    isCollapsing: true,
    children: [],
  },

  {
    permission: [PERMISSION.USER_READ, PERMISSION.ROLE_READ],
    iconComponent: 'iconUser',
    title: 'User Management',
    keyId: 'users',
    path: '/users',
    children: [
      {
        title: 'User',
        keyId: 'users-management',
        path: '/users/user',
        permission: PERMISSION.USER_READ,
      },
      {
        title: 'Role & Permission',
        keyId: 'users-role',
        path: '/users/role',
        permission: PERMISSION.ROLE_READ,
      },
    ],
  },

  {
    permission: [
      PERMISSION.BRAND_READ,
      PERMISSION.MODEL_READ,
      PERMISSION.YEAR_READ,
      PERMISSION.COLOR_READ,
      PERMISSION.BODY_TYPE_READ,
      PERMISSION.CONDITION_READ,
      PERMISSION.TRANSMISSION_READ,
      PERMISSION.FULE_TYPE_READ,
      PERMISSION.DEPARTMENT_READ,
      PERMISSION.FAQ_TYPE_READ,
      PERMISSION.SELLER_TYPE_READ,
      PERMISSION.APP_MENU_READ,
    ],
    iconComponent: 'iconSetting',
    title: 'Configuration',
    keyId: 'configuration',
    path: '/configuration/brands',
    children: [
      {
        title: 'Brand',
        keyId: 'configuration-brans',
        path: '/configuration/brands',
        permission: PERMISSION.BRAND_READ,
      },
      {
        title: 'Model',
        keyId: 'configuration-models',
        path: '/configuration/models',
        permission: PERMISSION.MODEL_READ,
      },
      {
        title: 'Year',
        keyId: 'configuration-year',
        path: '/configuration/years',
        permission: PERMISSION.YEAR_READ,
      },
      {
        title: 'Color',
        keyId: 'configuration-colors',
        path: '/configuration/colors',
        permission: PERMISSION.COLOR_READ,
      },
      {
        title: 'Body Type',
        keyId: 'configuration-body-type',
        path: '/configuration/body-types',
        permission: PERMISSION.BODY_TYPE_READ,
      },
      {
        title: 'Condition',
        keyId: 'configuration-condition',
        path: '/configuration/conditions',
        permission: PERMISSION.CONDITION_READ,
      },
      {
        title: 'Transmission',
        keyId: 'configuration-transmissions',
        path: '/configuration/transmissions',
        permission: PERMISSION.TRANSMISSION_READ,
      },
      {
        title: 'Fuel Type',
        keyId: 'configuration-fuel-types',
        path: '/configuration/fuel-types',
        permission: PERMISSION.FULE_TYPE_READ,
      },
      {
        title: 'Department',
        keyId: 'configuration-departments',
        path: '/configuration/departments',
        permission: PERMISSION.DEPARTMENT_READ,
      },
      {
        title: 'FAQ Type',
        keyId: 'configuration-faq-types',
        path: '/configuration/faq-types',
        permission: PERMISSION.FAQ_TYPE_READ,
      },
      {
        title: 'Seller Type',
        keyId: 'configuration-seller-types',
        path: '/configuration/seller-types',
        permission: PERMISSION.SELLER_TYPE_READ,
      },

      {
        title: 'App Menu',
        keyId: 'configuration-menu',
        path: '/configuration/app-menus',
        permission: PERMISSION.APP_MENU_READ,
      },
    ],
  },
];

export const filterMenu = (optionFilter = []) =>
  structuredClone(menuItems).filter(function f(o) {
    if (optionFilter.find((route) => (Array.isArray(o.permission) ? o.permission : [o.permission]).includes(route))) return true;
    if (o.children) {
      return (o.children = o.children.filter(f)).length;
    }
  });
